import { numberFormat } from "utils"

export const getDonutData = ({ filterData, data, dataObject }) => {
  if (Array.isArray(filterData)) return filterData
  if (Array.isArray(filterData?.[dataObject])) return filterData[dataObject]
  if (Array.isArray(data?.[dataObject])) return data[dataObject]
  return []
}

export const getDonutColorResolver = ({ colorScheme, schemes, colorFieldKey }) => {
  switch (colorScheme) {
    case "meetingAttendance":
      return datum => schemes?.meetingAttendanceDonut?.[datum[colorFieldKey]] ?? "#839FF4"
    case "auditReviews":
    case "reviewsRatings":
      return datum => schemes?.reviewsRatingsDonut?.[datum[colorFieldKey]] ?? "#E57373"
    default:
      return null
  }
}

export const getLegacyReviewBreakdownOrder = ({ activeTab, t }) => {
  const isLeadReviewDonut = activeTab?.loadType === "lead_review" || activeTab?.key === "lead_reviews"
  const isAuditReviewDonut = activeTab?.loadType === "audit_review" || activeTab?.key === "audit_reviews"
  if (isAuditReviewDonut) return [t("Call"), t("Lead"), t("Client"), t("Meeting")]
  if (isLeadReviewDonut) return [t("Call"), t("Lead"), t("Client")]
  return null
}

const getBreakdownValueByLabel = (breakdown, label) => {
  const matchedKey = Object.keys(breakdown).find(key => String(key).toLowerCase() === String(label).toLowerCase())
  return breakdown?.[matchedKey] ?? 0
}

export const getDonutTooltipFormatter = ({ angleField, colorField, useCompactBreakdown }) => {
  return (val, category, _index, datum) => {
    const rawValue = typeof val === "object" ? val?.[angleField] : val
    const name = typeof val === "object" ? val?.[colorField] : category
    const formattedValue = numberFormat(rawValue ?? 0, "en-US", 0)
    const breakdown = datum?.tooltipBreakdown
    if (breakdown && typeof breakdown === "object") {
      if (useCompactBreakdown) return { name: name ?? category, value: formattedValue }
      const breakdownText = Object.keys(breakdown)
        .map(key => `${key}: ${numberFormat(breakdown[key] ?? 0, "en-US", 0)}`)
        .join(" | ")
      return { name: name ?? category, value: breakdownText || formattedValue }
    }
    return { name: name ?? category, value: formattedValue }
  }
}

export const getDonutBreakdownTooltipContent = ({ colorFieldKey, breakdownOrder }) => {
  return (_title, items) => {
    const item = items?.[0]
    const datum = item?.data
    const breakdown = datum?.tooltipBreakdown
    if (!breakdown || typeof breakdown !== "object") return null

    const segmentName = datum?.[colorFieldKey] ?? item?.name ?? ""
    return (
      <div style={{ minWidth: 160, padding: "8px 10px" }}>
        <div style={{ fontWeight: 600, marginBottom: 8 }}>{segmentName}</div>
        {breakdownOrder.map(label => (
          <div key={label} style={{ display: "flex", justifyContent: "space-between", gap: 16 }}>
            <span>{label}:</span>
            <span>{numberFormat(getBreakdownValueByLabel(breakdown, label), "en-US", 0)}</span>
          </div>
        ))}
      </div>
    )
  }
}
